// extracted by mini-css-extract-plugin
export default {"zoomModal":"d1-z","image":"e1-z","button":"f1-z","isOverlayShown":"g1-z"};